import classNames from "classnames";

import ImageWrapper from "@components/swagmagic/dynamic/cards/image-wrapper";

import {
  CE_01,
  CE_02,
  CE_05,
  CE_06,
  CE_08,
  CE_09,
  CE_12,
  CE_14,
  CategoryVariant,
} from "@helpers/plasmic/slices";

import styles from "./main.module.scss";

export const INFO_CATEGORY_CARD_TYPE = "category";
export const INFO_BANNER_CARD_TYPE = "banner";

export type InfoCardType = typeof INFO_CATEGORY_CARD_TYPE | typeof INFO_BANNER_CARD_TYPE;

export type InfoCardProps = {
  src?: string;
  srcMobile?: string;
  srcTablet?: string;
  title: string;
  variant: CategoryVariant;
  type?: InfoCardType;
  isMultiSpan?: boolean;
};

const InfoCard = ({
  src,
  srcMobile,
  srcTablet,
  title,
  variant,
  type = INFO_CATEGORY_CARD_TYPE,
  isMultiSpan = false,
}: InfoCardProps) => {
  const isSmallCard = variant === CE_06;
  const isGridVariant = variant === CE_08 || variant === CE_09;
  const isCategoryVariant =
    variant === CE_01 || variant === CE_02 || variant === CE_06 || variant === CE_12;
  return (
    <div
      className={classNames({
        [styles.cardContainerSmall]: isSmallCard,
        [styles.cardContainer]: !isSmallCard,
        [styles.cardContainerLarge]: isMultiSpan,
        [styles.cardContainerRounded]: variant === CE_14,
        [styles.ce01Card]: isCategoryVariant,
      })}
    >
      <ImageWrapper
        src={src}
        srcMobile={srcMobile}
        srcTablet={srcTablet}
        alt={title}
        imageWrapperClassName={classNames({
          [styles.cardImageHolderSmall]: isSmallCard,
          [styles.cardImageHolder]: !isSmallCard,
          [styles.cardSquare]: variant === CE_05,
          [styles.cardRounded]: variant === CE_14,
          [styles.cardAspectRatioCe01]: type === INFO_CATEGORY_CARD_TYPE && isCategoryVariant,
          [styles.cardAspectRatio]:
            type === INFO_CATEGORY_CARD_TYPE && variant !== CE_14 && !isCategoryVariant,
          [styles.cardBanner]: type === INFO_BANNER_CARD_TYPE,
          [styles.cardGridRatio]: isGridVariant,
          [styles.cardContainerMultiColumn]: isMultiSpan,
        })}
        imageClassName={styles.cardImage}
        noImageText={title}
      />
      <div
        className={classNames(styles.cardTitle, {
          [styles.cardTitleSmall]: isSmallCard,
          [styles.cardTitleDefault]: !isSmallCard,
          [styles.cardRoundedTitle]: variant === CE_14,
        })}
      >
        {title}
      </div>
    </div>
  );
};

export default InfoCard;
